import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useUser, useDancesLeft } from '@state/uses/users'
import { useDanceOnAddProcess } from '@state/uses/dances'
import api from '@services/api'
import * as Utils from '@services/utils'
import { formInputHeight, useButtonWidth } from '@services/layout'
import TextInput from '@components/Form/TextInput'
import SelectInput from '@components/Form/SelectInput'
import MultiSelect from '@components/Form/MultiSelect'
import TextAreaInput from '@components/Form/TextAreaInput'
import StaticLabeledText from '@components/Form/StaticLabeledText'
import RequiredText from '@components/Form/RequiredText'
import SongDetails from '@components/AddEditDance/SongDetails'
import DanceSubmit from '@components/AddEditDance/DanceSubmit'
import MaterialDatePicker from '@components/Form/MaterialDatePicker'
import { FormInputContainer, FormInputLabel } from '@appearance/styled'
import i18n from '@localization/i18n'
import { DateInput } from 'grommet-controls'
import {
    PageHeader,
    PageSubTitle,
    FormRow,
    FormWrapper,
} from '@appearance/styled'
import urlUtils from '@services/urlUtils'
import {
    defaultDance,
    getDanceById,
    getCoChoreographersText,
    dateFormat,
    requestDateFormat,
    completionDateFormat,
    datePickerFormat,
} from '@services/dances'
import {
    DANCE_STATUS_ORDERED,
    DANCE_STATUS_APPROVED,
    DANCE_STATUS_EXISTS,
} from '@components/AddEditDance/StatusProgressButton'

const getUserFullName = (user) => user && user.first_name + ' ' + user.last_name
const combineSelectedChoreographers = (dance, setSelectedCoChoreographers) => {
    let selectedFilters = []
    const selectedFromArr = getCoChoreographersText(dance?.co_choreographers)
    const selectedFromString = getSelectedFromString(
        dance?.co_choreographers_string
    )
    //console.log('selectedFromString = ', selectedFromString)

    //selectedFilters = selectedFromArr.concat(selectedFromString)
    selectedFilters = mergeFilters(dance, selectedFromArr, selectedFromString)
    //console.log('selectedFilters23451235123 = ', selectedFilters)
    return selectedFilters
}

const getSelectedFromString = (co_choreographers_string) => {
    if (co_choreographers_string === '') return []
    const resArr = []
    const coChoreographersArr = co_choreographers_string?.split(', ')
    coChoreographersArr &&
        coChoreographersArr.map((item) => {
            resArr.push({ label: item, value: item })
        })
    return resArr
}

const mergeFilters = (dance, filtersArr1, filtersArr2) => {
    const choreographerFullName = getUserFullName(dance?.choreographer)

    let res = filtersArr1.filter((filter) => {
        return filter.label !== choreographerFullName
    })

    const arrayOfLabelsSelected = res.map((filter) => {
        return filter.label
    })

    filtersArr2 &&
        filtersArr2.map((filter) => {
            if (
                !arrayOfLabelsSelected.includes(filter.label) &&
                filter.label !== choreographerFullName
            ) {
                res.push(filter)
            }
        })
    return res
}

export default () => {
    const user = useUser()
    const history = useHistory()
    const dancesLeft = useDancesLeft()
    const buttonWidth = useButtonWidth()
    const danceOnAddProcess = useDanceOnAddProcess()
    const { id, ri } = urlUtils.getQueryParams()
    const [danceStylesOptions, setDanceStyleOptions] = useState([])
    const [choreographsOptions, setChoreographsOptions] = useState([])
    const [dance, setDance] = useState(id ? null : defaultDance)
    const [error, setError] = useState(null)
    const [selectedDate, setSelectedDate] = useState(null)
    const [selectedCoChoreographers, setSelectedCoChoreographers] = useState(
        combineSelectedChoreographers(dance)
    )
    const [shouldFixCoChoreographers, setShouldFixCoChoreographers] = useState(
        true
    )

    const requiredFieldEmptyText = i18n.t('edit_dance.input_missing')

    useEffect(() => {
        if (dance) {
            checkFormValidation()
            setSelectedDate(
                Utils.formatDate(dance.completion_date, datePickerFormat)
            )
            setSelectedCoChoreographers(combineSelectedChoreographers(dance))
        }
    }, [dance])
    useEffect(() => {
        if (dance && selectedCoChoreographers && shouldFixCoChoreographers) {
            fixCoChoreographsObj(selectedCoChoreographers)
            setShouldFixCoChoreographers(false)
        }
    }, [shouldFixCoChoreographers])

    const setDanceProperty = (propertyObj, secondPropObj) => {
        setDance(Object.assign({}, dance, propertyObj, secondPropObj))
    }

    const onCoChoreographersChange = (coChoreographersObj) => {
        const co_choreographers_string = updateCoChoreographersString(
            coChoreographersObj
        )
        dance.co_choreographers_string = co_choreographers_string
        setDanceProperty({ co_choreographers_string })
        fixCoChoreographsObj(coChoreographersObj)
        return
    }

    const updateCoChoreographersString = (coChoreographersObj) => {
        let co_choreographers_string = ''
        coChoreographersObj &&
            coChoreographersObj.map((item, index) => {
                co_choreographers_string += item.label + ', '
            })
        co_choreographers_string = co_choreographers_string?.slice(0, -2)
        return co_choreographers_string
    }

    const checkFormValidation = () => {
        setError(null)
        if (!dance.name || !dance.song.name) {
            setError(requiredFieldEmptyText)
        }
        if (
            dance.song.akum_id === 'not_found' &&
            (!dance.performer ||
                // (!dance.song.performer ||
                !dance.song.composer ||
                !dance.song.lyricist)
        ) {
            setError(requiredFieldEmptyText)
        }
    }

    useEffect(() => {
        throwBackIfNotPermitted()
        if (id) {
            getDanceById(id, setDance)
        }
        getDanceStylesOptions()
        getChoreographsOptions('')
    }, []) // run on init

    useEffect(() => {
        if (user && !id) {
            addChoreographerIdKey(user)
        }
    }, [user])

    useEffect(() => {
        if (!id && danceOnAddProcess) {
            setDance(danceOnAddProcess)
        }
    }, [danceOnAddProcess])

    const throwBackIfNotPermitted = () => {
        if (user && dance) {
            if (
                dance.id &&
                dance.choreographer.id !== user.user_id &&
                !user.is_admin
            ) {
                console.log('throwBackIfNotPermitted dance exist')
                history.goBack()
            }

            if (
                ((!dance.id && dancesLeft < 1) ||
                    (user && user.is_suspended)) &&
                !user.is_admin
            ) {
                console.log('throwBackIfNotPermitted dance NOT exist', {
                    dance,
                    dancesLeft,
                    user,
                })
                history.goBack()
            }
        }
    }

    const addChoreographerIdKey = (user) => {
        let fixedChor = user
        fixedChor.id = user.user_id
        setDance(Object.assign({}, dance, { choreographer: fixedChor }))
    }

    const getDanceStylesOptions = () => {
        api.getDanceStylesOptions().subscribe(
            (res) => {
                setDanceStyleOptions(res.data.res)
            },
            (error) => console.log('getDancesTypes from api error', error)
        )
    }

    const isTextInArr = (text, arr) => {
        let res = false
        arr.map((obj) => {
            if (obj.label === text) res = true
        })
        return res
    }

    const getChoreographsOptions = (inputText) => {
        const newCoChoreographer = {
            label: inputText + ' (הוסף חדש)',
            value: inputText,
        }
        api.getFilterOptions(
            'dances',
            'choreographer',
            ['first_name', 'last_name'],
            inputText
        ).subscribe(
            (res) => {
                console.log('getDancesTypes from api res', res)
                if (res.data.length > 0) {
                    let filterOptions = res.data
                    !isTextInArr(inputText, filterOptions) &&
                        filterOptions.push(newCoChoreographer)
                    setChoreographsOptions(filterOptions)
                } else {
                    setChoreographsOptions([newCoChoreographer])
                }
            },
            (error) => {
                setChoreographsOptions([newCoChoreographer])
                console.log('getDancesTypes from api error', error)
            }
        )
    }

    const updateSongDetail = (detailObj) => {
        const newSong = Object.assign({}, dance.song, detailObj)
        setDanceProperty({ song: newSong })
    }

    const updateSongAndDanceName = (name) => {
        const newSong = Object.assign({}, dance.song, { name })
        setDanceProperty({ song: newSong }, { name })
    }

    const fixCoChoreographsObj = (coChoreographsObj, returnVal = false) => {
        // make sure co_cChoreographers obj has 'id' and not 'value'
        //console.log('got onew filtes = ', coChoreographsObj)
        // setDanceProperty({ co_choreographers: { coChoreographsObj } })

        //const hebExpression = '(הוסף חדש)'
        let fixedObj = []
        if (coChoreographsObj) {
            coChoreographsObj.forEach((coChoreographer) => {
                if (coChoreographer.value) {
                    // if (coChoreographer.label.indexOf(hebExpression) < 1)
                    fixedObj.push({
                        id: coChoreographer.value,
                        label: coChoreographer.label,
                    })
                } else {
                    fixedObj.push(coChoreographer)
                }
            })
        }
        if (!returnVal) {
            setDanceProperty({ co_choreographers: fixedObj })
        } else return fixedObj
    }

    const showVideoExplanationText = () =>
        !dance.status || dance.status === DANCE_STATUS_ORDERED

    const showFullForm = () =>
        dance.id || !Utils.isEmptyStr(dance?.song?.akum_id)

    if (!user) {
        return null
    }

    if (!dance) {
        return null
    }

    const convertDateToTimestamp = (date) => {
        return new Date(date).getTime()
    }

    const onDateSelect = (date) => {
        setSelectedDate(
            Utils.formatDate(convertDateToTimestamp(date), datePickerFormat)
        )
        setDanceProperty({
            completion_date: convertDateToTimestamp(date),
        })
    }
    const checkPermissionByField = (field) => {
        if (user?.is_admin) return true
        const status = dance.status
        if (!status) return true
        if (DANCE_STATUS_EXISTS === status) return false
        if (DANCE_STATUS_ORDERED === status) return true
        if (DANCE_STATUS_APPROVED === status) {
            if (field === 'performer') return false
        }
        return true
    }
    const extractCoChoreographersString = () => {
        let res = []
        for (let i = 0; i < selectedCoChoreographers.length; i++) {
            res.push(selectedCoChoreographers[i].label.trim())
        }
        return res.join(', ')
    }

    console.log('add or edit dance', dance)
    return (
        <Main>
            <FirstSection>
                <PageHeader>
                    {dance.id
                        ? i18n.t('edit_dance.edit_dance')
                        : i18n.t('edit_dance.add_dance')}
                </PageHeader>
                <FormRow>
                    <StaticLabeledText
                        text={getUserFullName(dance.choreographer)}
                        label={i18n.t('edit_dance.ordered_by')}
                        width={buttonWidth}
                    />
                    {dance.status ? (
                        <StaticLabeledText
                            text={dance.status}
                            label={i18n.t('edit_dance.status')}
                            width={buttonWidth}
                        />
                    ) : (
                        <Flex1></Flex1>
                    )}
                    <Flex1 />
                </FormRow>
                <SongDetails
                    user={user}
                    dance={dance}
                    ri={ri}
                    updateSong={(song) => setDanceProperty({ song })}
                    updateSongAndDanceName={updateSongAndDanceName}
                    setDanceProperty={setDanceProperty}
                    checkPermissionByField={checkPermissionByField}
                />
            </FirstSection>

            {showFullForm() && (
                <FormWrapper>
                    <FormRow>
                        {checkPermissionByField() ? (
                            <SelectInput
                                value={dance?.style}
                                placeholder={i18n.t('edit_dance.select')}
                                label={i18n.t('edit_dance.dance_style')}
                                onSelect={(style) => {
                                    setDanceProperty({ style })
                                }}
                                options={danceStylesOptions}
                                onError={() => console.log('ERRRR')}
                                required={false}
                            />
                        ) : (
                            <StaticLabeledText
                                text={dance.style}
                                label={i18n.t('edit_dance.dance_style')}
                                width={buttonWidth}
                            />
                        )}
                        {checkPermissionByField() ? (
                            <MultiSelect
                                label={i18n.t('edit_dance.co_choreographers')}
                                placeholder={i18n.t('edit_dance.select')}
                                value={selectedCoChoreographers}
                                onChange={(co_choreographers) =>
                                    onCoChoreographersChange(co_choreographers)
                                }
                                onInputChange={(text) =>
                                    Utils.onControlledChange(
                                        text,
                                        0,
                                        getChoreographsOptions
                                    )
                                }
                                options={choreographsOptions}
                                inputHeight={formInputHeight}
                            />
                        ) : (
                            <StaticLabeledText
                                text={extractCoChoreographersString()}
                                label={i18n.t('edit_dance.co_choreographers')}
                                order_date_and_time
                                width={buttonWidth}
                            />
                        )}
                    </FormRow>
                    {dance.id && (
                        <FormRow>
                            <StaticLabeledText
                                text={Utils.formatDate(
                                    dance.request_date,
                                    requestDateFormat
                                )}
                                label={i18n.t('edit_dance.order_date_and_time')}
                                width={buttonWidth}
                            />
                            <StaticLabeledText
                                text={Utils.formatDate(
                                    dance.approval_date,
                                    dateFormat
                                )}
                                label={i18n.t('edit_dance.approval_date')}
                                width={buttonWidth}
                            />
                            {user?.is_admin &&
                            dance.status === DANCE_STATUS_EXISTS ? (
                                <FormInputContainer>
                                    <FormInputLabel lang={i18n.locale}>
                                        {i18n.t('edit_dance.compeletion_date')}
                                    </FormInputLabel>
                                    <MaterialDatePicker
                                        startDate={selectedDate}
                                        onChange={onDateSelect}
                                    />
                                </FormInputContainer>
                            ) : (
                                <StaticLabeledText
                                    text={Utils.formatDate(
                                        dance.completion_date,
                                        completionDateFormat
                                    )}
                                    label={i18n.t(
                                        'edit_dance.compeletion_date'
                                    )}
                                    width={buttonWidth}
                                />
                            )}
                        </FormRow>
                    )}
                    {dance.status && dance.status !== DANCE_STATUS_ORDERED && (
                        <FormRow>
                            <TextInput
                                text={dance.video_url || ''}
                                label={i18n.t('edit_dance.link_to_dance')}
                                onChangeText={(video_url) =>
                                    setDanceProperty({ video_url })
                                }
                                width={'100%'}
                            />
                        </FormRow>
                    )}

                    <FormRow>
                        <TextInput
                            text={dance.song.video_url || ''}
                            label={i18n.t('edit_dance.link_to_song')}
                            onChangeText={(video_url) =>
                                updateSongDetail({ video_url })
                            }
                            width={'100%'}
                        />
                    </FormRow>
                    <FormRow>
                        <TextInput
                            text={dance.song.lyrics || ''}
                            label={i18n.t('edit_dance.link_to_lyrics')}
                            onChangeText={(lyrics) =>
                                updateSongDetail({ lyrics })
                            }
                            width={'100%'}
                        />
                    </FormRow>

                    <FormRow>
                        <TextAreaInput
                            text={dance.notes || ''}
                            label={i18n.t('edit_dance.notes')}
                            onChangeText={(notes) =>
                                setDanceProperty({ notes })
                            }
                        />
                    </FormRow>
                    <FormRow>
                        <RequiredText />
                    </FormRow>
                    {showVideoExplanationText() && (
                        <FormRow>
                            <PageSubTitle>
                                {i18n.t('edit_dance.additional_info')}
                            </PageSubTitle>
                        </FormRow>
                    )}
                    <DanceSubmit dance={dance} error={error} />
                </FormWrapper>
            )}
        </Main>
    )
}

const Main = styled.div``

const Flex1 = styled.div`
    flex: 1;
    padding: 0 20px;
`

const FirstSection = styled(FormWrapper)`
    margin-bottom: 20px;
`
